/* ============================================================
   SAJ · CLIENT REVIEW FIXES 5 — "Website View Changes_final"
   (client doc 14.08.2026). Loads after saj-fix4.js.
   Purely additive: no template, section setting, navigation menu
   or uploaded asset is touched.
   ============================================================ */
(function () {
  'use strict';
  var d = document;
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* ==========================================================
     2 · 18K diamond pieces lost their price break-up
     ----------------------------------------------------------
     saj-fix3.js hides `.saj-pbk` unless a trust badge reads
     "BIS 916". Only 22K gold is badged that way — an 18K diamond
     piece is badged "18K Gold" — so every diamond product with an
     18K setting had its Product Details & Price Breakup hidden,
     which is exactly what the client found. Read the badge for
     what it actually says: any gold or platinum purity keeps the
     card, silver still loses it.
     ========================================================== */
  function pbkVisibility() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var badges = d.querySelector('.gal4-badges');
    var card = d.querySelector('.saj-pbk');
    if (!badges || !card) return;                    // no verdict to read
    var txt = $$('.gal4-badges .gb b').map(function (b) { return b.textContent || ''; }).join(' | ');
    var silver = /sterling|92\.?5|standard\s*silver/i.test(txt);
    var precious = /BIS\s*916|\d{2}\s*ct?\s*gold|\d{2}\s*k\b|platinum/i.test(txt);
    d.documentElement.classList.toggle('saj-pbk-ok', !silver && precious);
  }

  /* ==========================================================
     1 · every product claimed the same finish
     ----------------------------------------------------------
     The Specifications block is a section setting, so all 7,000+
     products printed "Finish: Antique / matte options" — the client
     rightly pointed out the catalogue has Antique, Nagas, Nakshi,
     Casting, Yellow Gold and more. Derive the real design and
     finish from the product's own tags, title and description
     (tags first, they are the reliable signal) and rewrite the
     line. Nothing is written back to the product.
     ========================================================== */
  var DESIGNS = [
    [/nakshi/, 'Nakshi'], [/nagas/, 'Nagas'], [/antique/, 'Antique'],
    [/casting/, 'Casting'], [/kundan/, 'Kundan'], [/polki/, 'Polki'],
    [/victorian/, 'Victorian'], [/swarovski/, 'Swarovski'],
    [/meenakari|enamel/, 'Meenakari'], [/filigree/, 'Filigree'],
    [/temple/, 'Temple'], [/navarathna|navaratna/, 'Navarathna'],
    [/traditional/, 'Traditional'], [/floral|flower/, 'Floral'],
    [/peacock/, 'Peacock'], [/lakshmi|vinayagar|ganesha/, 'Divine motif']
  ];
  var FINISHES = [
    [/rose\s*gold/, 'Rose Gold'], [/white\s*gold|rhodium/, 'White Gold'],
    [/yellow\s*gold/, 'Yellow Gold'], [/gold[\s-]*plated|micron/, 'Gold Plated'],
    [/oxidi[sz]ed/, 'Oxidised'], [/matte/, 'Matte'], [/high\s*polish/, 'High polish']
  ];
  function pick(list, hay, limit) {
    var out = [];
    for (var i = 0; i < list.length && out.length < (limit || 2); i++) {
      if (list[i][0].test(hay) && out.indexOf(list[i][1]) === -1) out.push(list[i][1]);
    }
    return out;
  }
  // the Specifications list is not always the first <ul> in the accordion — a
  // product whose description is written as a bullet list puts one ahead of it.
  // Find the list by the line we are here to rewrite, not by position.
  function findFinishLine() {
    var hit = null;
    $$('.saj-acc .acc-b li').some(function (x) {
      if (/^\s*finish\s*:/i.test(x.textContent || '')) { hit = x; return true; }
      return false;
    });
    return hit;
  }
  function purityText() {
    var t = '';
    $$('.saj-acc .acc-b li').forEach(function (x) {
      if (/^\s*purity\s*:/i.test(x.textContent || '')) t = x.textContent;
    });
    if (!t) t = $$('.gal4-badges .gb b').map(function (b) { return b.textContent || ''; }).join(' ');
    return t;
  }
  function applySpecs(p) {
    var li = findFinishLine();
    if (!li || li.dataset.sajSpec) return;
    li.dataset.sajSpec = '1';

    var tagsTitle = ((p.tags || []).join(' ') + ' ' + (p.title || '')).toLowerCase();
    var all = (tagsTitle + ' ' + (p.description || '').replace(/<[^>]+>/g, ' ')).toLowerCase();

    var design = pick(DESIGNS, tagsTitle, 2);
    if (!design.length) design = pick(DESIGNS, all, 1);

    var finish = pick(FINISHES, tagsTitle, 1);
    if (!finish.length) finish = pick(FINISHES, all, 1);
    if (!finish.length) {
      // no colour word anywhere — name the metal the purity line already states,
      // which is the honest answer for a plain 22K piece
      var pt = purityText();
      if (/sterling|92\.?5/i.test(pt)) finish = ['Sterling Silver'];
      else if (/silver/i.test(pt)) finish = ['Silver'];
      else if (/platinum/i.test(pt)) finish = ['Platinum'];
      else {
        var k = pt.match(/(\d{2})\s*K\b/i);
        finish = [(k ? k[1] + 'K ' : '') + 'Yellow Gold'];
      }
    }

    li.innerHTML = '<strong>Finish:</strong> ' + finish.join(' / ');
    if (design.length) {
      var dli = d.createElement('li');
      dli.className = 'saj-spec-design';
      dli.innerHTML = '<strong>Design:</strong> ' + design.join(' · ');
      li.parentNode.insertBefore(dli, li);
    }
  }
  function specFinish() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    if (!findFinishLine()) return;
    var key = 'saj_p_' + m[1];
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) { applySpecs(JSON.parse(hit)); return; }
    } catch (e) {}
    fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var slim = { tags: p.tags || [], title: p.title || '', description: (p.description || '').slice(0, 1200) };
        try { sessionStorage.setItem(key, JSON.stringify(slim)); } catch (e) {}
        applySpecs(slim);
      })
      .catch(function () {});
  }

  /* ==========================================================
     11 / 14 / 9 · text painted the same colour as its background
     ----------------------------------------------------------
     The July B2 rule `.saj-scope h2:not(.saj-faq-cat){color:#3D0A20}`
     outranks each dark band's own light colour, so any heading that
     sits on wine or charcoal is repainted near-black on near-black.
     saj-fix4.css patched the three bands found last round and
     saj-fix5.css patches the two photographed this round — this
     measures real contrast so any band added later is covered too.
     ========================================================== */
  function rgb(c) {
    var m = (c || '').match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }
  function lum(c) {
    function f(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b);
  }
  function contrast(a, b) {
    var l1 = lum(a), l2 = lum(b);
    return l1 < l2 ? (l2 + 0.05) / (l1 + 0.05) : (l1 + 0.05) / (l2 + 0.05);
  }
  function bgOf(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = getComputedStyle(n);
      // a gradient or a photograph is a background this cannot measure, and
      // walking past it would read the page behind it and get the answer
      // exactly backwards — that is how the wine WhatsApp band, which is a
      // linear-gradient, first got repainted dark by this very routine
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return null;
      var c = rgb(cs.backgroundColor);
      if (c && c.a > 0.85) return c;
    }
    return null;                                     // transparent all the way up — don't guess
  }
  function repaintDarkHeadings() {
    $$('.saj-scope h1,.saj-scope h2,.saj-scope h3,.saj-scope .serif').forEach(function (el) {
      if (el.dataset.sajLit) return;
      var t = (el.textContent || '').trim();
      if (!t) return;
      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4) return;
      var cs = getComputedStyle(el);
      var fg = rgb(cs.color);
      var bg = bgOf(el);
      if (!fg || !bg || fg.a < 0.3) return;
      // only ever lift a heading off a solid dark band. Never darken one:
      // the light-background cases are all legitimate design decisions and
      // second-guessing them is how this routine caused a regression.
      if (lum(bg) >= 0.3) return;
      if (contrast(fg, bg) >= 3) return;             // legible enough, leave it
      el.dataset.sajLit = '1';
      el.style.color = '#FFFDF8';
    });
  }

  /* ==========================================================
     16 · footer address broke across the pincode
     ----------------------------------------------------------
     "…Madurai —625" / "001". A pincode is one token to a reader,
     so glue its halves with a non-breaking space and let the line
     break somewhere that makes sense instead.
     ========================================================== */
  function fixAddressWrap() {
    $$('.saj-foot .saj-fgrid p, .saj-scope .v-list .rte').forEach(function (p) {
      if (p.dataset.sajAddr) return;
      p.dataset.sajAddr = '1';
      $$('*', p).concat([p]).forEach(function (node) {
        Array.prototype.forEach.call(node.childNodes, function (n) {
          if (n.nodeType !== 3) return;
          var v = n.nodeValue;
          // "625 001" is one token to a reader - glue it with a non-breaking space
          var out = v.replace(/(\d{3})[ \t]+(\d{3})(?!\d)/g, '$1 $2');
          if (out !== v) n.nodeValue = out;
        });
      });
    });
  }

  /* ==========================================================
     3 / 5 · the filter row scrolls, so its drop-downs must escape
     ----------------------------------------------------------
     saj-fix5.css puts Price / Jewel Type / In stock only / sort on
     one line inside a sideways scroller. A scroller clips whatever
     is absolutely positioned inside it, so the row is switched to
     overflow:visible while a chip is open. Modern browsers get this
     from :has() in the CSS; this is the fallback.
     ========================================================== */
  function filterBarScroll() {
    $$('.saj-scope .fbar .in').forEach(function (row) {
      if (row.dataset.sajFbar) return;
      row.dataset.sajFbar = '1';
      var sync = function () {
        row.classList.toggle('fbar-open', !!row.querySelector('details[open]'));
      };
      $$('details.fchip', row).forEach(function (x) { x.addEventListener('toggle', sync); });
      sync();
    });
  }

  /* ---------- run, and re-run when the theme re-renders ---------- */
  function run() {
    pbkVisibility();
    specFinish();
    repaintDarkHeadings();
    fixAddressWrap();
    filterBarScroll();
  }
  d.addEventListener('shopify:section:load', run);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
  // the pricing app, the cart drawer and the review rail all render late
  setTimeout(run, 1100);
  setTimeout(run, 3000);
})();
